import { useEffect, useRef, useState } from 'react';
import { Popover } from 'antd';
import { HolderOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import FillLightBar from '../../editLeftBar/fillLightBar'
import AiBeautyBar from '../../editLeftBar/aiBeautyBar'
import ImageFinerBar from '../../editLeftBar/imageFinerBar'
import MagicEraseBar from '../../editLeftBar/magicEraseBar'
import HandRepairBar from '../../editLeftBar/handRepairBar'
import OutpaintBar from '../../editLeftBar/outpaintBar'
import ResizePageLeft from '../../imageResize/resizePageLeft'
import styles from './index.module.scss'

const BASE_URL = 'https://photostudio-ai-oss.arcsoft.com.cn/photostudio-web/admin/batchProduceImages/'

const RightOperatePanel = (props) => {
    const panelRef = useRef(null)
    const dragStateRef = useRef(null)
    const [position, setPosition] = useState({ x: 12, y: 12 })

    const clampPosition = (nextPosition) => {
        const boundary = props.boundaryRef?.current
        const panel = panelRef.current
        if (!boundary || !panel) return nextPosition

        const maxX = Math.max(0, boundary.clientWidth - panel.offsetWidth - 12)
        const maxY = Math.max(0, boundary.clientHeight - panel.offsetHeight - 12)

        return {
            x: Math.min(Math.max(0, nextPosition.x), maxX),
            y: Math.min(Math.max(0, nextPosition.y), maxY),
        }
    }

    useEffect(() => {
        setPosition((prev) => clampPosition(prev))
    }, [props.activeKey])

    useEffect(() => {
        const handleResize = () => {
            setPosition((prev) => clampPosition(prev))
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    useEffect(() => {
        const handleMouseMove = (event) => {
            if (!dragStateRef.current) return
            const { offsetX, offsetY } = dragStateRef.current
            const boundary = props.boundaryRef?.current
            if (!boundary) return

            const boundaryRect = boundary.getBoundingClientRect()
            const nextPosition = clampPosition({
                x: event.clientX - boundaryRect.left - offsetX,
                y: event.clientY - boundaryRect.top - offsetY,
            })

            setPosition(nextPosition)
        }

        const handleMouseUp = () => {
            dragStateRef.current = null
        }

        window.addEventListener('mousemove', handleMouseMove)
        window.addEventListener('mouseup', handleMouseUp)
        return () => {
            window.removeEventListener('mousemove', handleMouseMove)
            window.removeEventListener('mouseup', handleMouseUp)
        }
    }, [])

    const handleDragStart = (event) => {
        const panel = panelRef.current
        if (!panel) return

        dragStateRef.current = {
            offsetX: event.clientX - panel.getBoundingClientRect().left,
            offsetY: event.clientY - panel.getBoundingClientRect().top,
        }
    }

    const ContentBox = (
        <div style={{ display: 'flex', gap: 12 }}>
            <div style={{ width: 180 }}>
                <img style={{ width: '100%', borderRadius: 8, display: 'block' }} src={BASE_URL + '1.png'} alt="标准模式" />
                <div style={{ marginTop: 8, fontWeight: 500 }}>标准模式</div>
                <div style={{ fontSize: 12, color: '#667085' }}>使人物与环境的光影和谐一致</div>
            </div>
            <div style={{ width: 180 }}>
                <img style={{ width: '100%', borderRadius: 8, display: 'block' }} src={BASE_URL + '2.png'} alt="人像模式" />
                <div style={{ marginTop: 8, fontWeight: 500 }}>人像模式</div>
                <div style={{ fontSize: 12, color: '#667085' }}>使人脸与身体的光影和谐一致</div>
            </div>
            <div style={{ width: 180 }}>
                <img style={{ width: '100%', borderRadius: 8, display: 'block' }} src={BASE_URL + '3.png'} alt="反光板模式" />
                <div style={{ marginTop: 8, fontWeight: 500 }}>反光板模式</div>
                <div style={{ fontSize: 12, color: '#667085' }}>使人脸光影更柔和，降低对比度</div>
            </div>
        </div>
    )

    const renderContent = () => {
        if (props.activeKey === 'filllight') {
            return (
                <div className={styles.OperateCard}>
                    <div className={styles.PanelTitle}>
                        <span>智能补光</span>
                        <Popover content={ContentBox} placement="right">
                            <QuestionCircleOutlined style={{ cursor: 'pointer' }} />
                        </Popover>
                    </div>
                    <div className={styles.CardBody}>
                        <FillLightBar saveResult={props.saveResult} isFilter={false} url={props.url} createClick={props.createClick} />
                    </div>
                </div>
            )
        }

        if (props.activeKey === 'beautify') {
            return (
                <div className={styles.OperateCard}>
                    <div className={styles.PanelTitle}>
                        <span>模特美化</span>
                    </div>
                    <div className={styles.CardBody}>
                        <AiBeautyBar
                            saveResult={props.saveResult}
                            oneClickFaceBeauty={props.oneClickFaceBeauty}
                            oneClickBodyBeauty={props.oneClickBodyBeauty}
                            url={props.url}
                            saveUndoList={props.saveUndoList}
                            faceArray={props.faceArray}
                            bodyArray={props.bodyArray}
                        />
                    </div>
                </div>
            )
        }


        if (props.activeKey === 'imageFiner') {
            return (
                <div className={styles.OperateCard}>
                    <div className={styles.PanelTitle}>
                        <span>AI超清</span>
                    </div>
                    <div className={styles.CardBody}>
                        <ImageFinerBar url={props.url} createClick={props.createClick} />
                    </div>
                </div>
            )
        }
        if (props.activeKey === 'magicErase') {
            return (
                <div className={styles.OperateCard}>
                    <div className={styles.PanelTitle}>
                        <span>魔法擦除</span>
                    </div>
                    <div className={styles.CardBody}>
                        <MagicEraseBar
                            url={props.url}
                            handleDraw={props.handleDraw}
                            repairSizeChange={props.repairSizeChange}
                            createClick={props.createClick}
                        />
                    </div>
                </div>
            )
        }

        if (props.activeKey === 'handRepair') {
            return (
                <div className={styles.OperateCard}>
                    <div className={styles.PanelTitle}>
                        <span>手部修复</span>
                    </div>
                    <div className={styles.CardBody}>
                        <HandRepairBar
                            url={props.url}
                            handleDraw={props.handleDraw}
                            repairSizeChange={props.repairSizeChange}
                            createClick={props.createClick}
                        />
                    </div>
                </div>
            )
        }

        if (props.activeKey === 'outpaint') {
            return (
                <div className={styles.OperateCard}>
                    <div className={styles.PanelTitle}>
                        <span>AI扩图</span>
                    </div>
                    <div className={styles.CardBody}>
                        <OutpaintBar
                            url={props.url}
                            multiple={props.outpaintConfig?.multiple}
                            ratio={props.outpaintConfig?.ratio}
                            generateCount={props.outpaintConfig?.generateCount}
                            onMultipleChange={props.onOutpaintMultipleChange}
                            onRatioChange={props.onOutpaintRatioChange}
                            onApply={props.onOutpaintApply}
                        />
                    </div>
                </div>
            )
        }

        if (props.activeKey === 'imageResize') {
            return (
                <div className={styles.OperateCard}>
                    <div className={styles.CardBody}>
                        <ResizePageLeft ref={props.imageResizeLeftRef} />
                    </div>
                </div>
            )
        }

        return <div className={styles.EmptyText}>当前功能无需额外操作</div>
    }

    return (
        <div
            ref={panelRef}
            className={styles.RightOperatePanel}
            style={{ left: `${position.x}px`, top: `${position.y}px` }}
        >
            <div className={styles.DragIconWrap} onMouseDown={handleDragStart}>
                <HolderOutlined className={styles.DragIcon} />
            </div>
            {renderContent()}
        </div>
    )
}

export default RightOperatePanel
